/**
 * @prettier
 */

import React from 'react';
import { connect } from 'react-redux';
import { Link } from '@zola/zola-ui';
import CardCorrectionReview from '../../CardCorrectionReview/CardCorrectionReview';
import { getPageData } from '../../../../reducers/pdp/selectors';
import FeatureFlags from '../../../../../util/featureFlags';
import OtherThingsToReview from './OtherThingsToReview';
import './TipsModals.less';

export function TipSTDFrontWithoutLinks() {
  return (
    <div className="etiquette-tip-modal">
      <div className="tip-content-container">
        <div className="modal-body">
          <h3>What To Include On Your Save The Date</h3>
          <div className="section">
            <p className="desc">
              Save the dates are like your wedding’s appetizers—they give your guests a taste of
              what’s to come. Make sure they sound delectable with these guidelines for exactly what
              to include:
            </p>
            <ul className="desc">
              <li>Your names</li>
              <li>Your wedding date</li>
              <li>The city and state of your wedding location</li>
              <li>An indication that a real invitation will follow</li>
              <li>Your wedding website and its password, if you’ve already set one up</li>
            </ul>
            <p className="desc">
              If you need a bit of inspiration, check out our{' '}
              <Link
                inline
                href="/expert-advice/invites-paper/save-the-dates/a-guide-to-save-the-dates/"
                target="_blank"
                rel="noopener noreferrer"
              >
                expert advice
              </Link>{' '}
              where you’ll find tons of insight based on the tone and formality you want to convey.
            </p>
          </div>
        </div>
      </div>
      <OtherThingsToReview />
    </div>
  );
}

export function TipSTDFrontWithLinksBase({ pageData }) {
  const themeKey = pageData && pageData.websiteTheme && pageData.websiteTheme.key;
  const websiteRoute = themeKey ? `/design/${themeKey}` : '';

  return (
    <div className="etiquette-tip-modal">
      <div className="tip-content-container">
        <div className="modal-body">
          <CardCorrectionReview.Title>
            What To Include On Your Save The Date
          </CardCorrectionReview.Title>
          <div className="section">
            <p className="desc">
              Save the dates are like your wedding’s appetizers—they give your guests a taste of
              what’s to come. Make sure they sound delectable with these guidelines for exactly what
              to include:
            </p>
            <ul className="desc">
              <li>Your names</li>
              <li>Your wedding date</li>
              <li>The city and state of your wedding location</li>
              <li>An indication that a real invitation will follow</li>
              <li>
                Your wedding website and its password.{' '}
                <Link inline target="_blank" href={`/wedding/manage/website${websiteRoute}`}>
                  Start your website with a matching design &#x279E;
                </Link>
              </li>
            </ul>
            <p className="desc">
              If you need a bit of inspiration, check out our{' '}
              <Link
                inline
                href="/expert-advice/invites-paper/save-the-dates/a-guide-to-save-the-dates/"
                target="_blank"
                rel="noopener noreferrer"
              >
                expert advice
              </Link>{' '}
              where you’ll find tons of insight based on the tone and formality you want to convey.
            </p>
          </div>
        </div>
      </div>
      <OtherThingsToReview />
    </div>
  );
}

export const mapStateToProps = state => ({
  pageData: getPageData(state),
});

export const TipSTDFrontWithLinks = connect(mapStateToProps)(TipSTDFrontWithLinksBase);

const TipSTDFrontSwitch = () => {
  if (FeatureFlags.get('invitesTipModalsWithLinks')) {
    return <TipSTDFrontWithLinks />;
  }

  return <TipSTDFrontWithoutLinks />;
};

export default TipSTDFrontSwitch;



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/TipsModals/TipSTDFront.jsx